import '../Styles/NavBar.css'
export function NavBar() {
    return (
        <div className="navBarMainDiv">
            <div className='navBarLinkDiv'>
                <a href="/" target='_self'><span>Home</span></a>
            </div>
            <div className='navBarLinkDiv'>
                <a href="/about" target='_self'><span>About Us</span></a>
            </div>
            <div className='navBarLinkDiv'>
                <a href="/constitution" target='_self'><span>Constitution</span></a>
            </div>
            <div className='navBarLinkDiv'>
                <a href="/page2" target='_self'><span>Page2</span></a>
            </div>
            <div className='navBarLinkDiv'>
                <a href="/page3" target='_self'><span>Page3</span></a>
            </div>
            <div className='navBarLinkDiv'>
                <a href="/page4" target='_self'><span>Page4</span></a>
            </div>
        </div>
    )
}